import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { VehicleAssignmentDTO } from '.';

export class VehicleAssignmentResponseModel extends GlobalResponseObject{
    data?: VehicleAssignmentDTO[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status: boolean, errorCode: number, internalMessage: string, data?: VehicleAssignmentDTO[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
